export type TimeKey = '100' | '75' | '50' | '25' | '10' | '0' | 'locked';

type GradientColors = { start: string; end: string };

export const colorsByTime: Record<TimeKey, GradientColors> = {
  '100': { start: '#B4E827', end: '#5CB800' },
  '75': { start: '#D4E827', end: '#88B300' },
  '50': { start: '#FFE040', end: '#FF8000' },
  '25': { start: '#FFAA88', end: '#FF4422' },
  '10': { start: '#FF5533', end: '#AA0000' },
  '0': { start: '#606060', end: '#2A2A2A' },
  locked: { start: '#D8D8D8', end: '#888888' },
};
